import { Divider, Input, Typography } from 'antd';
import styles from './index.module.css';

import Sheet from 'react-modal-sheet';

import { EditOutlined } from '@ant-design/icons';
import {
  categoriesMapping,
  categoryLogos,
  paymentModesMapping,
} from '../../../Utils/utils';
import { useContext, useState } from 'react';
import { DashboardContext } from '..';
import Search from 'antd/es/input/Search';
const DetailedTransaction: React.FC = () => {
  const [currentCategoryMapping, setCurrentCategoryMapping] =
    useState(categoriesMapping);
  const {
    currentMetaData,
    isDetailedTransactionSheetOpen,
    setIsDetailedTransactionSheetOpen,
  }: any = useContext(DashboardContext);

  const [isRetagging, setIsRetagging] = useState(false);
  const onCategorySearch = (inputText: any) => {
    if (inputText.currentTarget.value && inputText.currentTarget.value !== '') {
      const searchedCategory = Object.fromEntries(
        Object.entries(categoriesMapping).filter(
          ([key, value]: any) =>
            value
              .toLowerCase()
              .includes(inputText.currentTarget.value.toLowerCase()) ||
            key === 'OTHERS'
        )
      );
      setCurrentCategoryMapping(searchedCategory);
    } else {
      setCurrentCategoryMapping(categoriesMapping);
    }
  };
  const upadteCategory = (key: string) => {
    var localTxnArray = currentMetaData.txnArray;

    var localtxn = currentMetaData.transaction;
    var localDisplayName = localtxn.displayName.split('-')[1]
      ? localtxn.displayName.split('-')[1]
      : '';
    localtxn.categoryCode = key;
    localtxn.category = categoriesMapping[key];
    localtxn.displayName = categoriesMapping[key] + '-' + localDisplayName;

    localTxnArray[currentMetaData.index] = localtxn;
    currentMetaData.parentTransactionSetter({
      ...currentMetaData.parentTransactions,
      [currentMetaData.txn]: localTxnArray,
    });

    setIsRetagging(false);
    setIsDetailedTransactionSheetOpen(false);
  };
  return (
    <Sheet
      style={{ zIndex: 100 }}
      isOpen={isDetailedTransactionSheetOpen}
      onClose={() => {
        setIsDetailedTransactionSheetOpen(false);
      }}
      detent='content-height'
    >
      <Sheet.Container>
        <Sheet.Header />
        <div className={styles.detailsRoot}>
          <div className={styles.headerContianer}>
            <Typography.Text style={{ color: '#fff' }}>
              {currentMetaData.transaction.type === 'CREDIT'
                ? 'Amount Received'
                : 'Amount Paid'}
            </Typography.Text>
            <Typography.Title level={3} style={{ margin: 10, color: '#fff' }}>
              ₹ {currentMetaData.transaction.amount}
            </Typography.Title>
            <Typography.Text style={{ color: '#fff' }}>
              on {currentMetaData.txn}
            </Typography.Text>
            <Divider style={{ margin: 10 }} />
            <Typography.Text style={{ alignSelf: 'flex-start', color: '#fff' }}>
              {currentMetaData.transaction.type === 'CREDIT'
                ? 'Received from'
                : 'Paid to'}
            </Typography.Text>
            <Typography.Text
              style={{ alignSelf: 'flex-start', color: '#fff', fontSize: 12 }}
            >
              {currentMetaData.transaction.merchantName}
            </Typography.Text>
          </div>
          <div className={styles.bodyContainer} style={{ marginTop: 20 }}>
            <div className={styles.detailsContainer}>
              <Typography.Text style={{ color: 'grey' }}>
                Category
              </Typography.Text>

              <Typography.Text>
                {currentMetaData.transaction.category}{' '}
                <EditOutlined
                  onClick={() => setIsRetagging(!isRetagging)}
                  style={{ color: 'rgb(0, 46, 220)' }}
                />
              </Typography.Text>
            </div>
            <div className={styles.detailsContainer}>
              <Typography.Text style={{ color: 'grey' }}>
                Subcategory
              </Typography.Text>
              <Typography.Text>
                {currentMetaData.transaction.subcategory}
                {/* <EditOutlined /> */}
              </Typography.Text>
            </div>
            <div className={styles.detailsContainer}>
              <Typography.Text style={{ color: 'grey' }}>
                Payment mode
              </Typography.Text>

              <Typography.Text
                style={{ alignItems: 'center', display: 'flex' }}
              >
                <img
                  height={28}
                  src={
                    'https://logo.ignosis.ai/' +
                    paymentModesMapping[currentMetaData.transaction.paymentMode]
                      .id +
                    '.jpg'
                  }
                />
                {
                  paymentModesMapping[currentMetaData.transaction.paymentMode]
                    .name
                }
              </Typography.Text>
            </div>
          </div>
        </div>
        {isRetagging ? (
          <>
            <Typography.Text
              style={{
                padding: '0 20px 5px 20px',
                color: 'rgb(0, 46, 220)',
                fontWeight: 500,
              }}
            >
              Edit Categories
            </Typography.Text>
            <Search
              style={{ margin: '10px 20px', width: 'calc(100% - 40px)' }}
              placeholder='Search category'
              onChange={onCategorySearch}
            />
          </>
        ) : (
          <></>
        )}

        <Sheet.Scroller>
          {isRetagging ? (
            <div className={styles.categoryRoot}>
              {Object.keys(currentCategoryMapping).map((key: string) => {
                return (
                  <div
                    className={styles.categoryContainer}
                    onClick={() => {
                      upadteCategory(key);
                    }}
                  >
                    <img
                      height={24}
                      src={
                        'https://logo.ignosis.ai/' + categoryLogos[key] + '.jpg'
                      }
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src =
                          'https://logo.ignosis.ai/f7080c52-607c-46b3-8263-112cefcd5dae.jpg';
                      }}
                    />
                    <Typography.Text>{categoriesMapping[key]}</Typography.Text>
                  </div>
                );
              })}
            </div>
          ) : (
            <></>
          )}
        </Sheet.Scroller>
      </Sheet.Container>
      <Sheet.Backdrop onTap={() => setIsDetailedTransactionSheetOpen(false)} />
    </Sheet>
  );
};

export default DetailedTransaction;
